module.exports = "/_next/static/images/collapse-fdfc05f4d0e0ba0ba4dcc940a9198edc.svg";